import React from 'react';
import { IntlProvider } from 'react-intl';

import { rootStyleVariables } from '../../constants/rootStyleVariables';
import { dataLayerV2Hooks } from '../../hooks/dataLayerHooks/dataLayerV2Hooks';
import { featureStateHooks } from '../../hooks/featureStateHooks/featureStateHooks';
import { languageHooks } from '../../hooks/languageHooks/languageHooks';
import { messageHooks } from '../../hooks/messageHooks/messageHooks';
import { GlobalMessages } from '../../types/Messages';
import { ApplicationSiteGroup } from '../../types/commonEnums';
import { RoutingContainer } from '../RoutingContainer/RoutingContainer';

export const RootContainer = () => {
  const lang = messageHooks.useSubjectState(GlobalMessages.Language);

  const currentLanguage = languageHooks.useGetLanguage(lang,
    CONFIG.defaultLocale, CONFIG.applicationSiteGroup, CONFIG.locales);

  const langWithMessages = languageHooks.useGetLocaleAndMessage(currentLanguage);

  if (!langWithMessages) {
    return null;
  }

  const { locale, messages } = langWithMessages;
  dataLayerV2Hooks.useTrackViewItemListHandler();

  const {
    isGCSOrangeColor,
  } = featureStateHooks.useFeatureToggles();

  return (
    <div className={CONFIG.applicationSiteGroup === ApplicationSiteGroup.GCS && isGCSOrangeColor
      ? rootStyleVariables['GCSOrange'] : undefined}
    >
      <IntlProvider
        defaultLocale={CONFIG.defaultLocale}
        locale={locale}
        messages={messages}
      >
        <RoutingContainer />
      </IntlProvider>
    </div>
  );
};

RootContainer.displayName = 'RootContainer';
